export function findFieldByElement(fields = [], element) {
  return fields.find(field => field.element === element);
}
